import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/shared/lib/cn";

/**
 * A tiny meta tag — model capabilities ("Vision", "Thinking"), tiers, counts.
 * Capability tones carry a quiet hue; structural tones stay monochrome.
 */
export const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-sm font-sans font-medium uppercase tracking-[0.06em] [&_svg]:size-3",
  {
    variants: {
      tone: {
        outline: "bg-line-soft text-ink-muted",
        soft: "bg-line-soft text-ink-soft",
        ink: "bg-ink text-paper",
        violet: "bg-[var(--badge-violet-bg)] text-[var(--badge-violet-ink)]",
        amber: "bg-[var(--badge-amber-bg)] text-[var(--badge-amber-ink)]",
        teal: "bg-[var(--badge-teal-bg)] text-[var(--badge-teal-ink)]",
      },
      size: {
        xs: "h-[18px] px-1.5 text-[9.5px]",
        sm: "h-5 px-2 text-[10.5px]",
      },
    },
    defaultVariants: { tone: "outline", size: "xs" },
  },
);

export interface BadgeProps
  extends ComponentPropsWithoutRef<"span">,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, size, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone, size }), className)} {...props} />;
}
